import {createSlice} from "@reduxjs/toolkit";
import {fetchTreeThunk} from './fetchTree.thunk'
import {set} from "object-path-immutable";

const initialState = {
    isFetching: false,
    applicationId: null,
    appTree: [],
    isOpenedTreeDrawer: true,
    isOpenedImport: null,
    filter: {},
    selectedNodes: [],
    selectedRecord: {
        type: "",
        id: null
    }
}


export const applicationBuilderSlice = createSlice({
    name: 'applicationBuilder',
    initialState,
    reducers: {
        setSelectedRecord: (state, action) => {
            state.selectedRecord = {
                type: action.payload.type,
                id: action.payload.id
            }
        },
        toggleTreeDrawer: (state) => {
            state.isOpenedTreeDrawer = !state.isOpenedTreeDrawer
        },
        setApplicationId: (state, action) => {
            state.applicationId = action.payload;
        },
        insertSchemaProperties: (state, action) => {
            const {path, properties} = action.payload;
            const newPath = path.split(".").slice(2, path.split(".").length).join(".");
            state.appTree = set(state.appTree, "0." + newPath + ".properties", properties);
        },
        setOpenedImport: (state, action) => {
            state.isOpenedImport = action.payload;
        },
        filterTree: (state, action) => {
            const {key, filterString} = action.payload;
            state.filter[key] = filterString;
        },
        setSelectedNodes: (state, action) => {
            const {nodeIds, multiple} = action.payload;
            const findNode = state.selectedNodes.find((v) => v === nodeIds)

            if (findNode) {
                state.selectedNodes = state.selectedNodes.filter(nodeId => nodeId !== nodeIds)
                return;
            }

            state.selectedNodes = multiple ? [...state.selectedNodes, nodeIds] : [nodeIds];
        }
    },
    extraReducers: builder => {
        builder
            .addCase(fetchTreeThunk.fulfilled, (state, {payload}) => {
                state.appTree = payload;
                state.isFetching = false;
            })
            .addCase(fetchTreeThunk.rejected, (state, {payload}) => {
                //show error message
                console.log(payload)
                state.isFetching = false;
            })
            .addCase(fetchTreeThunk.pending, (state) => {
                state.isFetching = true;
            })
    }
})
export const {
    setSelectedRecord,
    toggleTreeDrawer,
    setApplicationId,
    insertSchemaProperties,
    setOpenedImport,
    filterTree,
    setSelectedNodes,
} = applicationBuilderSlice.actions;
export default applicationBuilderSlice.reducer;